// import React from 'react';
// import styles from './FooterMobile.module.css';
// import SocialMediaLinks from './SocialMediaLinks';
// import FooterColumn from './FooterColumn';
// import Logo from './Logo';

// const FooterMobile = () => {
//   const categoryLinks = [
//     'ריהוט לבית',
//     'מערכות ישיבה',
//     'פינות אוכל',
//     'ריהוט חצר וגינה',
//     'כסאות וכורסאות',
//     'שולחנות סלון'
//   ];

//   const mainLinks = [
//     'בית',
//     'אודות',
//     'קטלוג מוצרים',
//     'צור קשר'
//   ];

//   return (
//     <footer className={styles.footer}>
//       <div className={styles.footerContent}>
//         <div className={styles.footerColumns}>
//           <SocialMediaLinks />
//           <FooterColumn title="קטגוריות" links={categoryLinks} />
//           <FooterColumn title="ראשי" links={mainLinks} />
//           <Logo />
//         </div>
//         <div className={styles.footerBottom}>
//           <span className={styles.termsOfService}>תקנון אתר</span>
//           <span className={styles.copyright}>© כל הזכויות שמורות להומה מותגי יוקרה</span>
//         </div>
//       </div>
//     </footer>
//   );
// };

// export default FooterMobile;
import React, { useState } from "react";
import styles from './FooterMobile.module.css';
import SocialIcon from './SocialIcon';
import { useNavigate } from 'react-router-dom';

const categories = [
  { id: 1, name: "Indoor_outdoor_sofas", text: 'ספות פנים וחוץ' },
  { id: 2, name: "Armchairs", text: 'כורסאות' },
  { id: 3, name: "Coffee_tables_indoor_outdoor", text: 'שולחנות קפה פנים וחוץ' },
  { id: 4, name: "Dining_tables_indoor_outdoor", text: 'שולחנות אוכל פנים וחוץ' },
  { id: 5, name: "Chairs_and_bar_stools", text: 'כיסאות וכיסאות בר' },
  { id: 6, name: "Indoor_outdoor_lighting", text: 'תאורה פנים וחוץ' },
  { id: 7, name: "Accessories_and_complementary_furniture_indoor_outdoor", text: 'אקססוריז וריהוט משלים' },
  { id: 8, name: "Carpets", text: 'שטיחים' },
  { id: 9, name: "Shading_solutions", text: 'פתרונות הצללה' },
  { id: 10, name: "Outdoor_kitchens", text: 'מטבחי חוץ' },
  { id: 11, name: "Sunbeds_and_loungers", text: 'מיטות שיזוף ומרבצים' },
  { id: 12, name: "Ottomans_and_benches", text: 'הדומים וספסלים' },
  { id: 13, name: "Beds_for_bedrooms", text: 'מיטות לחדרי שינה' },
  { id: 14, name: "Office_tables", text: 'שולחנות משרד' },
  { id: 15, name: "Consoles_and_cabinets", text: 'קונסולות וארונות' },
  { id: 16, name: "All_products", text: 'כל המוצרים' },
];

const brands = [
  { name: "talenti", logoSrc: `${process.env.PUBLIC_URL}/logo_src_images/talenti.png` },
  { name: "artnova", logoSrc: `${process.env.PUBLIC_URL}/logo_src_images/artnova.png` },
  { name: "domkapa", logoSrc: `${process.env.PUBLIC_URL}/logo_src_images/domkapa.png` },
  { name: "Carpanese", logoSrc: `${process.env.PUBLIC_URL}/logo_src_images/carpanese.png` },
  { name: "PaoloCasteli", logoSrc: `${process.env.PUBLIC_URL}/logo_src_images/paolo_casteili.png` },
  { name: "naturedesign", logoSrc: `${process.env.PUBLIC_URL}/logo_src_images/naturedesign.png` },
  { name: "Ferri1956", logoSrc: `${process.env.PUBLIC_URL}/logo_src_images/Ferri1956.png` },
  { name: "Mohebbanmilano", logoSrc: `${process.env.PUBLIC_URL}/logo_src_images/mohebbanmilano.png` },
  { name: "laskasas", logoSrc: `${process.env.PUBLIC_URL}/logo_src_images/laskasas.png` },
  { name: "Snoc", logoSrc: `${process.env.PUBLIC_URL}/logo_src_images/nShoot.png` },
  { name: "Cane-Line", logoSrc: `${process.env.PUBLIC_URL}/logo_src_images/CANE-LINE.png` },
  { name: "Rugiano", logoSrc: `${process.env.PUBLIC_URL}/logo_src_images/RUGIANO.png` },
  { name: "Cprn", logoSrc: `${process.env.PUBLIC_URL}/logo_src_images/CPRN.png` },
  //   { name: "Franco_ferri", logoSrc: `${process.env.PUBLIC_URL}/logo_src_images/franco_ferri.png` },
];

const contentItems = [
  { icon: "https://cdn.builder.io/api/v1/image/assets/TEMP/7eec1e1fafb6713bfe94c36e2fe45a8cf028a7bc52440520344950374f5016da?placeholderIfAbsent=true&apiKey=61e6847707e64adabe6b05a1c0a8e8bd", text: "קטגוריות" },
  { icon: "https://cdn.builder.io/api/v1/image/assets/TEMP/f6278472007bd65f6aeaec0a23bd28fd8573826e8515bf2e33b741081204c95e?placeholderIfAbsent=true&apiKey=61e6847707e64adabe6b05a1c0a8e8bd", text: "מותגים" },
  { icon: "https://cdn.builder.io/api/v1/image/assets/TEMP/364b304387bbe60f3792bf2c4387460c0ac7cc5760c9e85a409ecd8ed605610f?placeholderIfAbsent=true&apiKey=61e6847707e64adabe6b05a1c0a8e8bd", text: "צור קשר" }
];

const socialIcons = [
  "https://cdn.builder.io/api/v1/image/assets/TEMP/fd4f680c08b035fed0824f77a28c1794d6b150c6a71c65a3e187225c3861ce68?placeholderIfAbsent=true&apiKey=61e6847707e64adabe6b05a1c0a8e8bd",
  "https://cdn.builder.io/api/v1/image/assets/TEMP/9b7f045ccf06042e3e6ee9d9c9436ed559a9adb3aea567feac2980c8d598ec1f?placeholderIfAbsent=true&apiKey=61e6847707e64adabe6b05a1c0a8e8bd",
  "https://cdn.builder.io/api/v1/image/assets/TEMP/33917e61b8c1ce048adafa565051a9a0e784ef302a9d950d4ef9cb9051236867?placeholderIfAbsent=true&apiKey=61e6847707e64adabe6b05a1c0a8e8bd"
];

function FooterMobile() {
  const navigate = useNavigate();
  const [isCategoriesOpen, setIsCategoriesOpen] = useState(false);
  const [isBrandsOpen, setIsBrandsOpen] = useState(false);

  const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
  };

  const handleCategoryClick = (categoryName) => {
    navigate(`/${categoryName}`);
    setIsCategoriesOpen(false);
  };

  const handleBrandClick = (brandName) => {
    let path;
    if (brandName === "PaoloCasteli" || brandName === "Cane-Line") {
      path = `/${brandName}`;
    } else {
      path = `/${capitalizeFirstLetter(brandName)}`;
    }
    navigate(path);
    setIsBrandsOpen(false);

    // navigate(`/${capitalizeFirstLetter(brandName)}`);
    // setIsBrandsOpen(false);
  };

  const handleContentItemClick = (text) => {
    if (text === "קטגוריות") {
      setIsCategoriesOpen(!isCategoriesOpen);
      setIsBrandsOpen(false); // סגירת מותגים אם פתוח
    } else if (text === "מותגים") {
      setIsBrandsOpen(!isBrandsOpen);
      setIsCategoriesOpen(false); // סגירת קטגוריות אם פתוח
    } else if (text === "צור קשר") {
      window.open('https://wa.me/message/RLCICLSB2DOOF1', '_blank');
    }
  };

  return (
    <footer className={styles.footer}>
      <nav className={styles.content}>
        {contentItems.map((item, index) => (
          <div key={index}>
            <div
              className={styles.contentItem}
              onClick={() => handleContentItemClick(item.text)}
            >
              <img src={item.icon} alt="" className={styles.icon} />
              <span className={styles.text}>{item.text}</span>
            </div>
            
            {/* הצגת קטגוריות כשהן פתוחות - רק אחרי הפריט "קטגוריות" */}
            {item.text === "קטגוריות" && isCategoriesOpen && (
              <div className={styles.categoriesMenu}>
                {categories.map((category) => (
                  <div
                    key={category.id}
                    className={styles.categoryItem}
                    onClick={() => handleCategoryClick(category.name)}
                  >
                    {category.text}
                  </div>
                ))}
              </div>
            )}
            
            {/* הצגת מותגים כשהם פתוחים - רק אחרי הפריט "מותגים" */}
            {item.text === "מותגים" && isBrandsOpen && (
              <div className={styles.brandsMenu}>
                {brands.map((brand, brandIndex) => (
                  <div
                    key={brandIndex}
                    className={styles.brandItem}
                    onClick={() => handleBrandClick(brand.name)}
                  >
                    <span className={styles.brandName}>{brand.name}</span>
                    <img src={brand.logoSrc} alt={brand.name} className={styles.brandLogo} />
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}
      </nav>
      <section className={styles.socialSection}>
        <h2 className={styles.followUs}>FOLLOW US</h2>
        <div className={styles.socialIcons}>
          {socialIcons.map((icon, index) => (
            <SocialIcon key={index} src={icon} />
          ))}
        </div>
      </section>
      <div className={styles.legalSection}>
        <div className={styles.legalLinks}>
          <span 
            className={styles.legalLink} 
            onClick={() => navigate('/terms-of-service')}
          >
            תנאי שימוש
          </span>
          <span 
            className={styles.legalLink} 
            onClick={() => navigate('/privacy-policy')}
          >
            מדיניות פרטיות
          </span>
        </div>
      </div>
      <div className={styles.copyright}>
        <p className={styles.copyrightText}>© כל הזכויות שמורות להומה מותגי יוקרה</p>
      </div>
    </footer>
  );
}

export default FooterMobile;